<template>
    <LayoutDefault>
        <Outstanding/>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Outstanding from "../components/Sections/Outstanding";

export default {
    components: {
        Outstanding,
        LayoutDefault,
    },
}
</script>
